import { Avatar, styled } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

/* be careful about modifying the style of this file,
  as it is consistent with the style of the products's details.
  src/components/ProductsDetailsList/ProductsDetailsListLineRendering/styles.ts
*/

export const StyledOverviewContainer = styled('div')(() => ({
  width: '100%',
}));

export const StyledMobileView = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    borderBottom: `1px solid ${theme.colors.grey.light3}`,
    padding: theme.spacing(2, 0),
  }),
);

export const StyledMobilePictoContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing(2),
  }),
);

export const StyledMobileSummaryCategory = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    paddingLeft: theme.spacing(2),
  }),
);

export const StyledMobileDataContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: theme.spacing(2),
  }),
);

export const StyledMobileDataItem = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    padding: theme.spacing(2, 2, 0, 0),
  }),
);

export const StyledDesktopView = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '100%',
    display: 'flex',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    borderBottom: `1px solid ${theme.colors.grey.light3}`,
    padding: theme.spacing(2, 0),
  }),
);

export const StyledLeftContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  width: '40%',
  maxWidth: '40%',
  minWidth: '40%',
}));

export const StyledPicto = styled('div')(() => ({
  flexGrow: 0,
}));

export const StyledSummaryCategory = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    flexGrow: 0,
    padding: theme.spacing(0, 4, 0, 2),
  }),
);

export const StyledNumberOfResultsDeclared = styled('div')(() => ({
  flexGrow: 0,
}));

export const StyledDataContainer = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'right',
  flexGrow: 1,
}));

export const StyledDataItem = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    paddingRight: theme.spacing(2),
    width: '30%',
    textAlign: 'right',
  }),
);

export const StyledRightContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'right',
  flexGrow: 0,
  width: 54,
}));

export const StyledUnitToDisplay = styled('span')(
  ({ theme }: { theme: ICustomTheme }) => ({
    marginLeft: theme.spacing(1),
  }),
);

export const StyledIcon = styled(Avatar)(
  ({ theme }: { theme: ICustomTheme }) => ({
    boxShadow: `0 0 10px 0 ${theme.colors.paletteFromBO.main}`,
    background: theme.colors.paletteFromBO.main,
  }),
);
